<template>
<div>
  <v-stepper v-model="el" class="elevation-0">
    <v-stepper-header>
      <v-divider></v-divider>
      <v-stepper-step :complete="el>1" step="1" color="#0c88c2">Approve Costs</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step color="#083a95" step="2">Summary</v-stepper-step>
      <v-divider></v-divider>
    </v-stepper-header>
    <v-divider></v-divider>
    <v-container container--fluid grid-list-md px-0>
      <v-row>
        <v-col d-flex cols="4" v-if="!hideRouteHowTo && $vuetify.breakpoint.mdAndUp">
          <RoutesInstructions />
        </v-col>
        <v-col
          :class="{'col-12': hideRouteHowTo,
        'col-12': $vuetify.breakpoint.smAndDown,
        'col-8': !hideRouteHowTo }">
          <v-stepper-content step="1" class="px-0">
            <section>
              <v-card style="background-color: #ECEFF1">
                <v-card-title>
                  <v-tooltip top color="secondary" v-if="$vuetify.breakpoint.mdAndUp">
                    <template v-slot:activator="{ on }">
                      <v-btn fab float-left top small @click="toggleHowTo" color="blue darken-1" v-on="on">
                        <v-icon v-if="!hideRouteHowTo" color="white">chevron_left</v-icon>
                        <v-icon v-if="hideRouteHowTo" color="white">chevron_right</v-icon>
                      </v-btn>
                    </template>
                    <span v-if="hideRouteHowTo">Show Instructions</span>
                    <span v-if="!hideRouteHowTo">Hide Instructions</span>
                  </v-tooltip>
                  <h1 class="mx-4">Search Routes</h1>
                  <v-btn icon @click="costDialog=true" color="blue darken-1" v-if="viewCostPermission">
                    <v-icon>local_atm</v-icon>
                  </v-btn>
                </v-card-title>

                <v-divider color="#42A5F5"/>

                <v-card-text>
                  <v-row align="center" justify="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
                    <v-col xl="1" lg="2" md="2" sm="10">
                      <h3 class="text-center">Select a date</h3>
                    </v-col>
                    <v-col xl="2" lg="3" md="3" sm="10">
                      <v-dialog
                        ref="dialog"
                        v-model="modal"
                        :return-value.sync="date"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="date"
                            label="Routes Date"
                            prepend-icon="event"
                            readonly
                            clearable
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="date" >
                          <v-spacer></v-spacer>
                          <v-btn text color="blue darken-1" @click="modal = false">Cancel</v-btn>
                          <v-btn text color="blue darken-1" @click="$refs.dialog.save(date)">OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-col>
                    <v-col xl="1" lg="2" md="2" sm="10">
                      <h3 class="text-center">And a region</h3>
                    </v-col>
                    <v-col xl="2" lg="3" md="3" sm="10">
                      <v-select
                        v-model="region"
                        :items="viewRoutesRegions"
                        item-text="name"
                        item-value="id"
                        menu-props="auto"
                        label="Select a Region"
                        hide-details
                        prepend-icon="map"
                        return-object
                        single-line
                        clearable
                        :menu-props="{transition:'slide-x-transition'}"
                        style="margin-top: 0 ; padding-top: 0"
                      ></v-select>
                    </v-col>
                    <v-col xl="2" lg="3" md="3" sm="10"></v-col>
                    <v-col xl="2" lg="3" md="3" sm="10"  v-show="isRouteAdmin">
                      <v-btn
                        class="mx-2"
                        @click="upapprovaldialog"
                        color="blue lighten-2"
                      >Roll back All
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </section>
            <section>
              <v-card ref="table" class="elevation-2">
                <v-card-title>
                  <v-container container--fluid>
                    <v-row justify="space-around" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
                      <v-col cols="12">
                        <h1 :class="{'text-little': $vuetify.breakpoint.smAndDown}">Routes Information</h1>
                      </v-col>

                      <v-col xl="2" lg="3" md="3" sm="10">
                        <v-text-field
                          label="Search..."
                          v-model="search"
                          prepend-icon="search"
                          single-line>
                        </v-text-field>
                      </v-col>

                      <v-col xl="2" lg="3" md="3" sm="10">
                        <v-select
                          v-model="approvalFilter"
                          :items="approvalLevels"
                          clearable
                          label="Filter by Level of Approval"
                          persistent-hint
                        />
                      </v-col>

                      <v-col xl="2" lg="3" md="3" sm="10">
                        <v-switch
                          class="justify-center"
                          v-model="closedSwitch"
                          :label="closedSwitch ? 'Closed Routes' : 'Opened Routes'"
                          :disabled="lastLoad === 'open'"
                        />
                      </v-col>

                      <v-col xl="2" lg="3" md="3" sm="10" v-if="branchAdmin && finalAdmin">
                        <v-switch
                          color="green"
                          class="justify-center"
                          v-model="approvalSwitch"
                          :label="approvalSwitch ? 'Approve as: Final' : 'Approve as: Branch'"
                        >
                        </v-switch>
                      </v-col>

                      <v-col lg="2" md="2" sm="10" v-else-if="branchAdmin && !finalAdmin">
                        You are approving as Branch.
                      </v-col>
                      <v-col lg="2" md="2" sm="10" v-else-if="!branchAdmin && finalAdmin">
                        You are approving as Final.
                      </v-col>
                      <v-col lg="2" md="2" sm="10" v-else>
                        You are in Read-only mode
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-title>

                <v-divider color="#42a5f5"/>

                <v-data-table
                  :headers="headers"
                  :items="renderedRoutes"
                  item-key="id"
                  :loading="loading"
                  :search="search"
                  :expanded="expanded"
                  show-expand
                  :options="options"
                  :items-per-page="itemsPerPage"
                  sort-by="name"
                >
                  <template v-slot:item.approved="props">
                    <v-checkbox
                      class="justify-center"
                      :input-value="isChecked(props.item)"
                      @change="routeSelected(props.item, $event)"
                      :color="props.item.approval_level==='final'? 'green':'#00a7d3'"
                      primary
                      hide-details
                      :disabled="(!branchAdmin && !finalAdmin) || props.item.closed || (props.item.approval_level === 'final' && approvalLevel === 'branch')"
                    />
                  </template>

                  <template v-slot:item.approval_delivery_penalty="props">
                    ${{ props.item.approval_delivery_penalty ? props.item.approval_delivery_penalty : props.item.delivery_penalty}}
                  </template>

                  <template v-slot:item.approval_delivery_bonus_cost="props">
                    ${{ props.item.approval_delivery_bonus_cost ? props.item.approval_delivery_bonus_cost : props.item.delivery_bonus_cost}}
                  </template>

                  <template v-slot:item.approval_delivery_base_cost="props">
                    ${{ props.item.approval_delivery_base_cost ? props.item.approval_delivery_base_cost : props.item.delivery_base_cost}}
                  </template>

                  <template v-slot:item.actions="props">
                    <v-icon small
                            @click="editPrice(props.item)"
                            :disabled="isChecked(props.item) || (!branchAdmin && !finalAdmin) || props.item.closed">
                      edit
                    </v-icon>
                  </template>

                  <template v-slot:expanded-item="props">
                    <td :colspan="headers.length" class="px-0">
                      <v-card>
                        <v-card-title class="justify-center">
                          <h2>Information</h2>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                          <v-row justify="space-around" align="center" no-gutters>
                            <v-col cols="12" md="6"
                                   v-for="(field, index) in Object.keys(props.item)"
                                   :key="index"
                            >
                              <v-row justify="center" align="center">
                                <v-col cols="6" md="4" class="raleway-bold py-1" :class="$vuetify.breakpoint.smAndDown ? 'text-right' : 'text-center'">
                                  {{fieldsHeader[field]}}
                                </v-col>
                                <v-col cols="6" md="8" class="py-1" :class="$vuetify.breakpoint.smAndDown ? 'text-left' : 'text-center'">
                                  {{Object.values(props.item)[index]}}
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </td>
                  </template>
                </v-data-table>

                <v-card-actions v-show="lastLoad === 'region_date'">
                  <v-container container--fluid grid-list-xl>
                    <v-row justify="center">
                      <v-btn block text :disabled="!this.approvalLevel" color="light-blue darken-1" @click="finalise">
                        Finalise
                      </v-btn>
                    </v-row>
                  </v-container>
                </v-card-actions>
              </v-card>
            </section>
          </v-stepper-content>

          <v-stepper-content step="2" class="pa-0">
            <section>
              <v-card>
                <v-card-title>
                  <v-row justify="space-around" align="center"
                         :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
                    <v-col md="5" sm="12" class="text-center">
                      <h1 :class="{'text-little': $vuetify.breakpoint.smAndDown}">
                        Routes summary
                      </h1>
                    </v-col>

                    <v-col cols="1">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn color="blue darken-1 headline" text v-on="on" @click="info = !info">
                            <span class="v-btn__content" style="font-size: 22px;">?</span>
                          </v-btn>
                        </template>
                        <span>Display information about this page</span>
                      </v-tooltip>
                    </v-col>

                  </v-row>
                </v-card-title>

                <v-alert :value="info" type="info" color="blue darken-1" transition="slide-y-transition" class="mb-0">
                  <v-row :class="$vuetify.breakpoint.smAndDown ? 'text-center' : 'justify-space-around'">
                    <v-col md="4" sm="12" class="justify-center">
                      <span style="white-space: nowrap" :class="{'body-2': $vuetify.breakpoint.smAndDown}">Routes requiring further approval</span>
                      <v-icon color="orange">fiber_manual_record</v-icon>
                    </v-col>

                    <v-col md="4" sm="12" class="justify-center">
                      <span style="white-space: nowrap" :class="{'body-2': $vuetify.breakpoint.smAndDown}">Approved routes</span>
                      <v-icon color="green">fiber_manual_record</v-icon>
                    </v-col>
                  </v-row>
                </v-alert>

                <v-divider color="#42a5f5"></v-divider>

                <v-data-table
                  :items="processedRoutes"
                  :headers="headersStep2"
                >
                  <template v-slot:item.status="props">
                    <v-icon :color="props.item.closed ? 'green' : 'orange'">fiber_manual_record</v-icon>
                  </template>

                  <template v-slot:item.total_cost="props">
                    ${{ totalApprovalCost(props.item) }}
                  </template>
                </v-data-table>

                <v-card-actions class="justify-center">
                  <v-btn text color="blue darken-1" @click="refresh=!refresh;el=1">Done</v-btn>
                </v-card-actions>
              </v-card>
            </section>
          </v-stepper-content>

        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="alertDialog" width="500px">
      <v-card background-color="#ECEFF1">
        <v-card-title class="display-1 justify-center">
          ALERT
        </v-card-title>
        <v-divider color="#42a5f5"></v-divider>
        <v-card-text class="text-center">{{message}}</v-card-text>
        <v-card-actions>
          <v-row justify="center">
            <v-btn text color="blue darken-1" @click="alertDialog=false">Close</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editPriceDialog" width="800px">
      <v-card>
        <v-card-title class="display-1 justify-center">
          <h2>Edit route {{editedItem.id}}</h2>
        </v-card-title>

        <v-divider color="#42a5f5"></v-divider>

        <v-card-text>
          <v-container container--fluid grid-list-xl>
            <v-row justify="space-around">
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:keyup.esc="close"
                  v-on:keyup.enter="save"
                  label="Delivery Penalty"
                  :value="editedItem.delivery_penalty"
                  v-model="editedItem.approval_delivery_penalty"
                  prefix="$"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:keyup.esc="close"
                  v-on:keyup.enter="save"
                  label="Delivery Bonus"
                  v-model="editedItem.approval_delivery_bonus_cost"
                  prefix="$"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:keyup.esc="close"
                  v-on:keyup.enter="save"
                  label="Delivery Base"
                  :value="editedItem.delivery_base_cost"
                  v-model="editedItem.approval_delivery_base_cost"
                  prefix="$"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="space-around">
              <v-text-field
                v-on:keyup.esc="close"
                v-on:keyup.enter="save"
                label="Comments"
                :value="editedItem.approval_comments"
                v-model="editedItem.approval_comments"
              ></v-text-field>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighten-2" @click="close">Close</v-btn>
          <v-btn text color="blue darken-1" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-stepper>

  <v-dialog v-model="costDialog">
    <v-card>
      <v-card-title class="d-flex" style="position: relative" :class="$vuetify.breakpoint.smAndDown ? 'justify-start' : 'justify-center'">
        <h2>Edit Route Costs</h2>
        <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="costDialog=false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row justify="center">
          <v-col cols="12" md="4">
            <v-select
              :items="viewCostsRegions"
              item-text="name"
              return-object
              v-model="viewCostRegion"
              prepend-icon="fas fa-map"
              label="Region..."></v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <RouteCostStructureDataTable
        v-if="viewCostRegion"
        :region="viewCostRegion"
      ></RouteCostStructureDataTable>
    </v-card>
  </v-dialog>


  <v-dialog
    v-model="unapprovalDialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title class="justify-center">
        <h3>ATTENTION</h3>
      </v-card-title>
      <v-card-text class="text-center" >
        You are about to roll back all approval routes with date is {{date}} and region is {{region_name}}. This action cannot be undone. <br>
        Are you sure you want to proceed ?
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn text @click="unapprovalDialog=false" color="blue-grey lighten-2">No</v-btn>
        <v-btn text @click="toggleUnapproval" color="blue darken-1">Yes</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>



</div>
</template>

<script>
import axios from 'axios';
import RoutesInstructions from "./Routes/RoutesInstructions";
import RouteCostStructureDataTable from "./Routes/RouteCostStructureDataTable";

export default {
  name: 'Routes',
  components: {
    RoutesInstructions,
    RouteCostStructureDataTable,
  },
  data () {
    return {
      alertDialog: false,
      approvalFilter: undefined,
      approvalLevels: [
        {text: 'No Approval', value: 'none'},
        {text: 'Branch Approval', value: 'branch'},
        {text: 'Final Approval', value: 'final'}
      ],
      approvalSwitch: false,
      closedSwitch: false,
      costDialog: false,
      unapprovalDialog: false,
      date: '',
      defaultItem: {
        delivery_penalty: 0,
        delivery_bonus_cost: 0,
        delivery_base_cost: 0,
        approval_comments:null
      },
      editPriceDialog: false,
      editedIndex: -1,
      editedItem: {
        delivery_penalty: 0,
        delivery_bonus_cost: 0,
        delivery_base_cost: 0,
        approval_comments:null
      },
      el: 1,
      expanded: [],
      fieldsHeader: {
        id: 'ID',
        date: 'Date',
        depot_id: 'Depot ID',
        depot_name: 'Depot',
        region_id: 'Region ID',
        region_name: 'Region',
        pin: 'PIN',
        stops_total: 'Total Stops',
        stops_on_hold: 'Stops On Hold',
        stops_rescheduled: 'Rescheduled Stops',
        distance_estimated: 'Estimated Distance',
        drive_time_estimated: 'Estimated Drive Time',
        first_estimated: 'First Estimated',
        last_estimated: 'Last Estimated',
        in_order: 'In Order',
        delivery_bonus_cost: 'Delivery Bonus Cost',
        scanning_cost: 'Scanning Cost',
        bonus_eligible: 'Bonus Eligible',
        closed: 'Closed',
        approval_delivery_base_cost: 'Approved Delivery Base Cost',
        approval_delivery_penalty: 'Approved Delivery Penalty',
        approval_delivery_bonus_cost: 'Approved Delivery Bonus Cost',
        approval_comments:'Approval Comments',
        approval_time: 'Approval Time',
        name: 'Name',
        user: 'User',
        revenue: 'Revenue',
        stops_processed: 'Processed Stops',
        stops_cancelled: 'Cancelled Stops',
        stops_pending: 'Pending Stops',
        distance_actual: 'Actual Distance',
        drive_time_actual: 'Actual Drive Time',
        first_actual: 'First Actual',
        last_actual: 'Last Actual',
        delivery_base_cost: 'Delivery Base Cost',
        delivery_penalty: 'Delivery Penalty',
        it_cost: 'IT Cost',
        notes: 'Notes',
        approved_by: 'Approved By',
        approvalLevel: 'Approval Level',
        approval_level: 'Checked Approval Level',
      },
      headersStep2: [
        {text: 'Status', sortable: false, align: 'center', value: 'status'},
        {text: 'Date', sortable: true, align: 'center', value: 'date'},
        {text: 'Depot', sortable: false, align: 'center', value: 'depot_name'},
        {text: 'Approved By', sortable: false, align: 'center', value: 'approved_by'},
        {text: 'Level of Approval', sortable: false, align: 'center', value: 'approval_level'},
        {text: 'Total Cost', sortable: true, align: 'center', value: 'total_cost'},
      ],
      info: false,
      lastLoad: null,
      loading: false,
      message: null,
      modal: false,
      processedRoutes: [],
      refresh: false,
      region: null,
      search: null,
      statusFilter: null,
      statusFilterItems: [
        {text: 'All', value: null},
        {text: 'Closed', value: true},
        {text: 'Opened', value: false}
      ],
      today: new Date().toISOString().substr(0, 10),
      viewCostRegion: null,
      itemsPerPage: 10
    }
  },
  computed: {
    approvalLevel() {
      if (this.finalAdmin) {
        if (this.branchAdmin) {
          return this.approvalSwitch ? 'final' : 'branch';
        }
        return 'final'
      }
      if (this.branchAdmin) return 'branch';
      return null;
    },
    branchAdmin() {
      return this.$store.getters['auth/hasPermission']('route_cost_branch_approval');
    },
    finalAdmin() {
      return this.$store.getters['auth/hasPermission']('route_cost_final_approval');
    },
    hideRouteHowTo() {
      return this.$store.state.preferences.hideRouteHowTo;
    },
    viewRoutesRegions() {
      return this.$store.getters['auth/permissionRegions']('route_view');
    },
    viewCostsRegions() {
      //return this.$store.getters['auth/permissionRegions']('route_cost_structure_view');
      let regions = this.$store.getters['auth/permissionRegions']('route_cost_structure_view');
      const hasGlobal = regions.some(r => r.id === 0);
      if (!hasGlobal) {
        const globalRegion = this.$store.state.auth.regions.find(r => r.id === 0);
        if (globalRegion) {
          regions = [globalRegion, ...regions];
        } else {
          regions = [{ id: 0, name: 'Global', code: 'BCC' }, ...regions];
        }
      }
      return regions;
    },
    viewCostPermission() {
      return this.$store.getters['auth/hasPermission']('route_cost_structure_view');
    },
    isRouteAdmin() {
      return this.$store.getters['auth/hasPermission']('route_admin');
    },
    renderedRoutes() {
      let routes = this.routes ? this.routes : [];
      routes = routes.filter((route) => {
        return route.closed === this.closedSwitch;
      })
      if (this.approvalFilter) {
        routes = routes.filter((route) => {
          if (this.approvalFilter === 'none') {
            return route.approval_level === null;
          } else return route.approval_level === this.approvalFilter;
        })
      }
      if (this.region) {
        routes = routes.filter((route) => {
          return this.region.id === route.region_id;
        })
      }
      if (this.date) {
        routes = routes.filter((route) => {
          return this.date === route.date;
        })
      }
      return routes;
    },
    headers() {
      if (this.date !== null && this.region !== null) return [
        {text: 'Approved', value: 'approved', sortable: false, align: 'center'},
        {text: 'Route Name', sortable: true, value: 'name', align: 'center'},
        {text: 'Pin', value: 'pin', align: 'center'},
        {text: 'Distance (km)', value: 'distance_estimated', align: 'center'},
        {text: 'Time ', value: 'drive_time_estimated', align: 'center'},
        {text: 'Number of Drops Processed', value: 'stops_processed', align: 'center'},
        {text: 'Penalty ($)', value: 'approval_delivery_penalty', align: 'center'},
        {text: 'Bonus ($)', value: 'approval_delivery_bonus_cost', align: 'center'},
        {text: 'Cost ($)', value: 'approval_delivery_base_cost', align: 'center'},
        {text: 'Actions', value: 'actions', align: 'center', sortable: false},
        {text: '', value: 'data-table-expand'}
      ]; else return [
        {text: 'Date', sortable: true, value: 'date', align: 'center'},
        {text: 'Depot Name', sortable: true, value: 'depot_name', align: 'center'},
        {text: 'Route Name', sortable: true, value: 'name', align: 'center'},
        {text: 'Pin', value: 'pin', align: 'center'},
        {text: 'Distance (km)', value: 'distance_estimated', align: 'center'},
        {text: 'Time ', value: 'drive_time_estimated', align: 'center'},
        {text: 'Number of Drops Processed', value: 'stops_processed', align: 'center'},
        {text: 'Approval Level', value: 'approval_level', align: 'center'},
        {text: 'Penalty ($)', value: 'approval_delivery_penalty', align: 'center'},
        {text: 'Bonus ($)', value: 'approval_delivery_bonus_cost', align: 'center'},
        {text: 'Cost ($)', value: 'approval_delivery_base_cost', align: 'center'},
        {text: '', value: 'data-table-expand'}
      ];
    },
    options() {
      if (this.lastLoad === 'open') return {
        itemsPerPage: this.itemsPerPage,
        sortBy: ['date', 'depot_name'],
        multiSort: true,
      };
      else return {
        itemsPerPage: this.itemsPerPage,
        sortBy: ['name'],
        multiSort: false,
      };
    },
    computedMaxDate() {
      const offsetHours = -new Date().getTimezoneOffset() / 60;
      // Check if the timezone is in the USA range (UTC-10 to UTC-4)
      if (offsetHours >= -10 && offsetHours <= -4) {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        return tomorrow.toISOString().substr(0, 10);
      } else {
        return this.today;
      }
    },
  },
  asyncComputed: {
    async routes() {
      if (this.refresh || !this.refresh) {
        if (!this.date || !this.region) {
          if (this.lastLoad !== 'open') {
            this.loading = true;
            this.lastLoad = 'open';
            return await axios.get(process.env.API_URL + '/routes?open=true')
              .then((response) => {
                this.loading = false;
                return response.data;
              });
          }
          return this.routes;
        } else {
          this.loading = true;
          this.lastLoad = 'region_date'
          return await axios.get(process.env.API_URL + '/routes?date=' + this.date + '&region=' + this.region.id)
            .then((response) => {
              this.loading = false;
              return response.data;
            });
        }
      }
    }
  },
  methods: {
    toggleHowTo() {
      this.$store.commit('preferences/toggle', 'hideRouteHowTo');
    },
    routeSelected(item, checked) {
      if (checked) {
        // Approve route
        axios.post(process.env.API_URL + '/routes/' + item.id + '/approvals', {
          "delivery_base_cost": item.approval_delivery_base_cost === null ? item.delivery_base_cost : item.approval_delivery_base_cost,
          "delivery_bonus_cost": item.approval_delivery_bonus_cost === null ? item.delivery_bonus_cost : item.approval_delivery_bonus_cost,
          "delivery_penalty": item.approval_delivery_penalty === null ? item.delivery_penalty : item.approval_delivery_penalty,
          "type": this.approvalLevel,

          "comments":item.approval_comments
        })
          .then((response) => {
            if (response.status === 200) {
              item.approval_level = response.data.type;
            }
          })
          .catch((error) => {
            item.refresh = true;
            this.alertDialog = true;
            this.message = 'Error approving route'
          })
      } else {
        // Delete approval
        axios.delete(process.env.API_URL + '/routes/' + item.id + '/approvals?type=' + this.approvalLevel)
          .then((response) => {
            this.updateDataTable();
          })
          .catch((error) => {
            item.approval_level = this.approvalLevel;
            this.alertDialog = true;
            this.message = 'Error unapproving route'
          });
      }
    },
    isChecked(item) {
      return item.approval_level === 'final' || (item.approval_level === 'branch' && this.approvalLevel === 'branch')
    },
    updateDataTable() {
      this.refresh = ! this.refresh;
    },
    editPrice(item) {
      this.editedIndex = this.routes.indexOf(item);
      this.editedItem = Object.assign({}, item);
      if (this.editedItem.approval_delivery_base_cost === null || this.editedItem.approval_delivery_bonus_cost === null ||
        this.editedItem.approval_delivery_penalty === null) {
        this.editedItem.approval_delivery_bonus_cost = this.editedItem.delivery_bonus_cost;
        this.editedItem.approval_delivery_penalty = this.editedItem.delivery_penalty;
        this.editedItem.approval_delivery_base_cost = this.editedItem.delivery_base_cost;
      }
      this.editPriceDialog = true;
    },
    close() {
      this.editPriceDialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },
    save() {
      if (this.editedItem.approval_comments == null || this.editedItem.approval_comments.length < 5) {
        if (this.editedItem.delivery_base_cost != this.editedItem.approval_delivery_base_cost ||
          this.editedItem.delivery_bonus_cost != this.editedItem.approval_delivery_bonus_cost ||
          this.editedItem.delivery_penalty != this.editedItem.approval_delivery_penalty) {
          alert("Comments required");
          return;
        }
      }
      if (this.editedIndex > -1) {
        this.editedItem.delivery_base_cost = parseFloat(this.editedItem.delivery_base_cost);
        this.editedItem.delivery_bonus_cost = parseFloat(this.editedItem.delivery_bonus_cost);
        this.editedItem.delivery_penalty = parseFloat(this.editedItem.delivery_penalty);
        Object.assign(this.routes[this.editedIndex], this.editedItem);
      }
      this.close();
    },
    finalise() {
      if (this.routes.some((route) => {
        if (!this.isChecked(route)) {
          return true;
        }
      })) {
        this.message = 'Please approve all routes before finalising';
        this.alertDialog = true;
      } else {
        let ids = this.routes.map((route) => { return {id: route.id} });
        axios.post(process.env.API_URL + '/routes/close', ids)
          .then((response) => {
            this.processedRoutes = response.data;
            this.el = 2;
          })
          .catch(() => {
            this.alertDialog = true;
            this.message = "An error occurred whilst finalising";
          })
      }
    },
    totalApprovalCost(route) {
      return parseFloat(route.approval_delivery_base_cost) + parseFloat(route.approval_delivery_bonus_cost) - parseFloat(route.approval_delivery_penalty);
    },
    toggleUnapproval(){
      if(this.region === null || this.date === null){
        this.$store.commit('displaySnackbar', 'please select region and date');
        return;
      }

      let body ={
        region_id:this.region.id,
        date:this.date
      };

      axios.post(process.env.API_URL + '/routes/unapprovals', body)
        .then((response) => {
          if (response.status === 200) {
            this.updateDataTable();
            this.unapprovalDialog = false;
          }
        })
        .catch((error) => {
          this.unapprovalDialog = false;
          this.message = 'Error roll back approving route'
        })
    },
    upapprovaldialog(){
       this.unapprovalDialog = true;
    },


  },
  mounted() {
    if ((this.$route.query.date !== null && this.$route.query.date !== undefined) && (this.$route.query.region !== null && this.$route.query.region !== undefined)) {
      this.date = this.$route.query.date;
      this.viewRoutesRegions.forEach((region) => {
        if (region.id === parseInt(this.$route.query.region)) {
          this.region = region;
        }
      });
    }

    if (this.$route.query.approvalLevel === 'Branch' || this.$route.query.approvalLevel === 'Final') {
      this.approvalFilter = this.$route.query.approvalLevel.toLowerCase();
    }
    if (this.$route.query.approveAs === 'Branch' || this.$route.query.approveAs === 'Final') {
      this.approvalSwitch = (this.$route.query.approveAs === 'Final');
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Routes.vue